import { IconButton } from "../../components/ui";
import { useT } from "../../i18n/strings";
import { setViewMode, useViewMode } from "./useViewMode";

/**
 * One button, not two: with only two modes the icon can show the mode you
 * would switch *to*, which is one less control in an already busy header.
 */
export function ViewToggle() {
  const t = useT();
  const mode = useViewMode();
  const next = mode === "list" ? "grid" : "list";

  return (
    <IconButton
      name={next === "grid" ? "viewGrid" : "viewList"}
      label={next === "grid" ? t.actions.viewGrid : t.actions.viewList}
      // Moving between two views is a selection tick, not the light impact
      // every other button gives.
      feedback="select"
      onClick={() => setViewMode(next)}
    />
  );
}
